module.exports = __webpack_public_path__ + "fd5a608a/img/73000000-2.2b1422b6.png";